<template lang="pug">
el-collapse(v-model='indicesCollapseReservaLegal')
    el-collapse-item(:name='`collapse-reserva-legal`')
        template(slot='title')
            span.titulo Reserva legal
        .collapse-item-bloco-info
            .info
                label Área de reserva legal averbada vetorizada:
                span {{ formatNumber(dados?.areaReservaLegalAverbada, 2) }}
            .info
                label Área de reserva legal aprovada não averbada vetorizada:
                span {{ formatNumber(dados?.areaReservaLegalNaoAverbada, 2) }}
            .info
                label Área de reserva legal proposta vetorizada:
                span {{ formatNumber(dados?.areaReservaLegalProposta, 2) }}
            .info
                label Total de reserva legal declarada pelo proprietário/possuidor:
                span {{ formatNumber(dados?.areaReservaLegalDeclarada, 2) }}
</template>

<script>
import formatter from '@/utils/formatters';

export default {
    name: 'CollapseReservaLegal',
    props: {
        dados: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            indicesCollapseReservaLegal: []
        };
    },
    methods: {
        formatNumber(number, decimalPlaces = 2) {
            if (!number) return '-';
            return formatter.formatNumber(number, decimalPlaces) + ' ha';
        }
    }
};
</script>

<style lang="scss">
.titulo {
    font-weight: bold;
}
</style>
